// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QMmi","left":"styles_left__1mZoA"};